export const strippedHtmlLength = (source: string) => {
  return source.replace(/(<([^>]+)>)/gi, '').length
}
